export default "__VITE_ASSET__BjLOqKd7__"